import { InfoIcon } from '../assets/svgImages';
import { InfoBoxProps } from '../interface/interface';

/**
 * InfoBox component displays a styled alert box with the provided content.
 *
 * @param {InfoBoxProps} props - The properties for the InfoBox component.
 * @param {string} props.content - The content to be displayed inside the alert box.
 * @param {string} props.boldContent - The bold content to be displayed inside the alert box.
 * @param {string} props.className - The class names to be displayed inside the alert box.
 * @param {boolean} props.isIconEnable - Whether the icon wants to be displayed inside the alert box.
 * @param {string} props.iconClassName - The class names for the icon in the alert box.
 *
 * @returns {JSX.Element} A styled div element containing the alert content.
 */
const InfoBox = (props: InfoBoxProps): JSX.Element => (
  <div
    className={`p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 flex items-center ${props.className}`}
    role="alert"
  >
    {props.isIconEnable ? (
      <InfoIcon className={`w-6 ${props.iconClassName}`} />
    ) : null}
    <span>
      {props.content}
      <b>{props.boldContent}</b>
    </span>
  </div>
);

export default InfoBox;
